import React from 'react';
const stats = [{
  value: '+1.800',
  label: 'estudiantes confían'
}, {
  value: '6+6',
  label: 'Tomos + Bonos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'LM',
  quote: '"Tenía tres parciales en el mismo mes y aprobé todo sin quedarme una sola noche sin dormir."',
  author: '— Lucía M., Córdoba | 2° año Psicología UNC'
}, {
  initials: 'FS',
  quote: '"Antes perdía horas buscando apuntes que no coincidían. Con el MegaPack supe exactamente qué estudiar y en qué orden."',
  author: '— Florencia S., Buenos Aires | 3° año Psicología UBA'
}, {
  initials: 'VP',
  quote: '"Me dio el orden que la facultad nunca me dio. Ya aprobé 6 materias y por primera vez entiendo lo que estudio."',
  author: '— Valentina P., Rosario | 2° año Psicología UNR'
}];
export function SocialProof() {
  return <section className="relative w-full px-4 sm:px-6 lg:px-8 py-10 text-base leading-6" style={{
    background: 'linear-gradient(180deg, #FDF4E7 0%, #FEFAF4 40%, #FEFAF4 60%, #FDF4E7 100%)'
  }} data-id="element-291">
      <div className="mx-auto max-w-4xl" data-id="element-292">

        {/* STATS */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-293">
          {stats.map(stat => <div key={stat.label} data-id="element-294">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black" style={{
            color: '#1E1208'
          }} data-id="element-295">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold" style={{
            color: '#7A9E7E'
          }} data-id="element-296">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* TESTIMONIALS */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-297">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 rounded-lg p-3 shadow-sm" style={{
          backgroundColor: 'rgba(255,255,255,0.85)',
          border: '1px solid rgba(200,146,42,0.22)'
        }} data-id="element-298">
              {/* Avatar */}
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-black" style={{
            background: 'linear-gradient(135deg, rgba(200,146,42,0.15) 0%, rgba(122,158,126,0.15) 100%)',
            color: '#C8922A'
          }} data-id="element-299">
                {t.initials}
              </div>

              {/* Content */}
              <div data-id="element-300">
                <div className="mb-1 text-[10px]" style={{
              color: '#C8922A'
            }} data-id="element-301">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium m-0 leading-relaxed" style={{
              color: '#1E1208'
            }} data-id="element-302">
                  {t.quote}
                </p>
                <p className="text-[10px] mt-1 mb-0" style={{
              color: '#9A7B5A'
            }} data-id="element-303">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>

      {/* Degradé → PainPoints */}
      <div className="absolute bottom-0 left-0 w-full h-16 pointer-events-none" style={{
      background: 'linear-gradient(180deg, transparent 0%, #FEFAF4 100%)'
    }} data-id="element-304" />
    </section>;
}